import * as React from 'react';
import { Skeleton } from '@frontend/shadcn/components/ui/skeleton';
import { MainMetric } from '@frontend/app/refresh-components';
import { WidgetContainer } from '@frontend/app/refresh-components';

interface StatCardProps {
    title: string;
    bgColor: string;
    widgetIcon: React.ReactNode;
    value: number;
    metricType: 'number' | 'currency' | 'count';
    trendIncrease?: number;
    subHeading?: string;
    primaryPopoverText?: React.ReactNode;
    secondaryPopoverText?: React.ReactNode;
    isLoading?: boolean;
    tooltip?: string;
    secondaryValue?: {
        value: number;
        symbol?: string;
    };
}

export function StatCard({
    title,
    bgColor,
    widgetIcon,
    value,
    metricType,
    trendIncrease,
    subHeading,
    primaryPopoverText,
    secondaryPopoverText,
    isLoading,
    tooltip,
    secondaryValue,
}: StatCardProps) {
    const loadingContent = (
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
      </div>
    );

    const mainContent = (
      <MainMetric
        value={value}
        size="xsmall"
        icon={null}
        metricType={metricType}
        trend={trendIncrease}
        subHeading={subHeading}
        className="pt-0 -mt-2"
        popoverTextPrimary={primaryPopoverText}
        popoverTextSecondary={secondaryPopoverText}
        secondaryValue={secondaryValue}
      />
    );

    return (
      <WidgetContainer widgetTitle={title} bgColor={bgColor} widgetIcon={widgetIcon} tooltip={tooltip}>
        {isLoading ? loadingContent : mainContent}
      </WidgetContainer>
    );
}
